import { useQueryClient } from '@tanstack/react-query';
import { Divider, Form, notification } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'moment/locale/en-gb';
import dayjs from 'dayjs';
import UploadFilesDragger from '../../components/UploadFiles/UploadFilesDragger';
import { handleUpdateMyday } from '../../fetchHooks/handleUpdateMyday';
import type { MydayType } from '../../fetchHooks/useMyday';
import type { UserType } from '../../fetchHooks/useUserProfile';
import { MydayForm } from './MydayForm';

interface EditMydayProps {
  onOk: () => void;
  onClose: () => void;
  showModal: boolean;
  userProfile?: UserType;
  myday: MydayType;
}

export const ModalTitle = ({ title }: { title: string }) => (
  <>
    <h1
      style={{
        textAlign: 'center',
        paddingBottom: '2rem',
        paddingTop: '2rem',
        background: 'rgba(147, 188, 255, 0.3)',
        borderRadius: 16,
      }}
    >
      {title}
    </h1>
    <Divider />
  </>
);

export const EditMyday = ({ onOk, onClose, showModal, userProfile, myday }: EditMydayProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  console.log('EditMyday');

  useEffect(() => {
    showModal && form.setFieldsValue({ date: dayjs() });
  }, [showModal, form]);

  useEffect(() => {
    showModal &&
      form?.setFieldsValue?.({
        ...myday,
        date: dayjs(myday.date),
        type: myday.type,
        measurements: [],
      });
  }, [form, myday, showModal]);

  if (!showModal) return <></>;

  const onFinish = async (values: MydayType) => {
    const d = new Date(values.date);
    const data = {
      ...values,
      userId: userProfile?.id,
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate(),
    };
    await handleUpdateMyday(data, myday, queryClient, onOk);
    notification.success({
      message: t('myday.mydayUpdated'),
    });
  };

  if (!userProfile) return null;

  return (
    <Modal
      open={showModal}
      onCancel={onClose}
      style={{ minHeight: '50vh', padding: 0, borderRadius: '20px' }}
      width="1280px"
      footer={null}
      centered
      destroyOnHidden
    >
      <ModalTitle title={t('myday.editLifeLogModal')} />
      <MydayForm onFinish={onFinish} form={form} onCancel={onClose} myday={myday} isEdit type={myday.type}>
        <UploadFilesDragger myday={myday} />
      </MydayForm>
    </Modal>
  );
};
